// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
import { delete_account } from './delete-account';
import { globalText as global } from './global';
import { magazines } from './magazines';
import { spot } from './spot';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  delete_account,
  global,
  magazines,
  spot,
};
